import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=2c353aaa&scoped=true"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"
import style0 from "./CreateReport.vue?vue&type=style&index=0&id=2c353aaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c353aaa",
  null
  
)

export default component.exports